import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import ModalSection from '../ModalSection';
import PromptModel from '../../../../models/PromptModel';
import { SIDEBAR_ACTIONS } from '../../../../../constants/actionsConstants';
import RightModalLayout from '../../../../layouts/Modal/RightModalLayout';
import QuillComponent from '../QuillComponent';

const InteractionExamplesModal = ({ agentId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('ChatbotIA');

  const [examplesInteraction, setExamplesInteraction] = useState('');
  const [promptId, setPromptId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadExamplesInteractionContent();
  }, [agentId]);

  const toggleInteractionExamplesModal = () => {
    dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
  };

  const loadExamplesInteractionContent = () => {
    if (!agentId) {
      showtoast(t('config.error_loading'));
      setLoading(false);
      return;
    }

    setLoading(true);
    PromptModel.get(agentId, { type: 'examples_interactions' })
      .then((response) => {
        const prompts = response.data || [];
        const examplesPrompt = prompts.find(p => p.type === 'examples_interactions');

        if (examplesPrompt) {
          setExamplesInteraction(examplesPrompt.prompt || '');
          setPromptId(examplesPrompt.id);
        } else {
          setExamplesInteraction('');
          setPromptId(null);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        showtoast(err.error || t('config.error_loading'));
      });
  };

  const updateInfo = (value) => {
    setExamplesInteraction(value);
  };

  const onSubmit = () => {
    if (!agentId) {
      showtoast(t('config.error_loading'));
      return;
    }

    const params = promptId
      ? { prompt: examplesInteraction }
      : { type: 'examples_interactions', prompt: examplesInteraction };

    setSaving(true);

    const savePromise = promptId
      ? PromptModel.update(agentId, promptId, params)
      : PromptModel.save(agentId, params);

    savePromise
      .then((result) => {
        if (!promptId && result?.id) {
          setPromptId(result.id);
        }
        setTimeout(() => {
          showtoast(t('config.save_success'));
          setSaving(false);
          toggleInteractionExamplesModal();
        }, 1000);
      })
      .catch((error) => {
        setSaving(false);
        showtoast(error.message || t('config.save_error'));
      });
  };

  return (
    <div className="tw-wrapper">
      <RightModalLayout
        title={t('config.examples_interaction.modal_title')}
        submitAction={onSubmit}
        submitLabel={t('guides.sidebar_create.update')}
        submitDisabled={saving}
      >
        <ModalSection
          title={t('config.examples_interaction.section_1_title')}
          description={t('config.examples_interaction.section_1_description')}
          afterContent={(
            <QuillComponent
              name="examples_interaction"
              value={examplesInteraction || ''}
              onChange={(value) => { updateInfo(value); }}
              overflowHidden={false}
            />
          )}
        />
      </RightModalLayout>
    </div>
  );
};

export default InteractionExamplesModal;
